<template>
  <div class="log">
    <basic-container>
      <avue-crud
        ref="crud"
        :key="tableKey"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        :permission="permissionList"
        @on-load="getPage"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @sort-change="sortChange"
        @row-del="handleDel"
      >
      <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { delObj, pageByUserId as getPage } from "@/api/upms/log";
import {tableOption} from '@/const/crud/upms/user'
export default {
  data() {
    return {
      tableKey:0,
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [],
        descs: "create_time",
      },
      tableLoading: false,
      tableOption: tableOption,
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        delBtn: this.permissions["sys:log:del"] ? true : false,
      };
    },
  },
  mounted: function () {
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  methods: {
    updateTableHeight() {
        this.tableOption.height= this.$calculateTableHeight(
          this.$refs.crud.$refs.table
        )  
        this.tableKey += 1
    },
    exOut(){
      this.$refs.crud.rowExcel()
    },
    reset() {
      this.$refs.crud.searchReset();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
            // createId: this.userInfo.id
          },
          params
        )
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.page.currentPage = page.currentPage;
        this.page.pageSize = page.pageSize;
        this.tableLoading = false;
      });
    },
    handleDel: function (row, index) {
      var _this = this;
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          this.getPage(this.page);
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
        })
        .catch(function (err) {});
    },
    /**
     * 搜索回调
     */
    searchChange(form, done) {
      this.getPage(this.page, form);
      // done();
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.reset{
  margin-left: 14px;
}
/deep/.el-icon-printer{
  display: none!important;
}
</style>